import './zipper-signin';
import type { ZipperSignin } from './zipper-signin';

/**
 * Mount the customer email-code sign-in modal on the host page and resolve when
 * the customer signs in (or never, if they cancel). Shared by every "Sign in"
 * affordance across the embeds.
 */
export function openSignIn(
  orgId: number,
  accent: string,
  onSignedIn?: (firstName?: string) => void,
): void {
  const el = document.createElement('zipper-signin') as ZipperSignin;
  el.orgId = orgId;
  el.accent = accent;
  let removed = false;
  const cleanup = () => {
    if (removed) return;
    removed = true;
    el.remove();
  };
  el.addEventListener('zipper-signin-close', cleanup);
  el.addEventListener('zipper-signed-in', (e) => {
    onSignedIn?.((e as CustomEvent).detail?.firstName);
    cleanup();
  });
  document.body.appendChild(el);
}
